"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsFieldLogic = void 0;
var tags_fieldtype_1 = require("./tags.fieldtype");
Object.defineProperty(exports, "TagsFieldLogic", { enumerable: true, get: function () { return tags_fieldtype_1.TagsFieldLogic; } });
